const FRONTEND_CONFIG = {
  baseUrl: String(import.meta.env.VITE_SITE_ORIGIN ?? '').trim() || '/',
  docsOrigin: new URL(
    '/docs',
    String(import.meta.env.VITE_DOCS_ORIGIN ?? '').trim() || 'https://docs.localhost:4003/docs',
  ).href,
};

const DOCS_PREFIX = '/docs';

function stripTrailingSlash(path: string): string {
  if (path.length <= 1) return path;
  return path.endsWith('/') ? path.slice(0, -1) : path;
}

export function getSiteBase(): string {
  const base = FRONTEND_CONFIG.baseUrl;
  return stripTrailingSlash(base) || '/';
}

export function getDocsOrigin(): string {
  return stripTrailingSlash(FRONTEND_CONFIG.docsOrigin);
}

export function isHttpUrl(value: string): boolean {
  return /^https?:\/\//.test(value);
}

function toSiteAbsolutePath(pathOrHash: string): string {
  if (!pathOrHash) return '/';
  if (pathOrHash.startsWith('#')) return `${window.location.pathname}${pathOrHash}`;
  const normalized = pathOrHash.startsWith('/') ? pathOrHash : `/${pathOrHash}`;
  const base = getSiteBase();
  if (base === '/') return normalized;
  return `${base}${normalized}`;
}

export function maybeDocsHref(target: string): string | null {
  if (!target.startsWith(DOCS_PREFIX)) return null;
  const docsOrigin = getDocsOrigin();
  const suffix = target === DOCS_PREFIX ? '/' : target.slice(DOCS_PREFIX.length);
  return `${docsOrigin}${suffix.startsWith('/') ? suffix : `/${suffix}`}`;
}

export function resolveHref(target: string): string {
  if (isHttpUrl(target)) return target;

  const docsHref = maybeDocsHref(target);
  if (docsHref) return docsHref;

  return toSiteAbsolutePath(target);
}

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  const clean = pathname.split('?')[0].split('#')[0];
  const normalized = clean.startsWith('/') ? clean : `/${clean}`;
  return stripTrailingSlash(normalized) || '/';
}
